module.exports = __webpack_public_path__ + "static/media/necaxa.425656ee.png";